import React from 'react';
import PropTypes from 'prop-types';
import s from './Section.module.scss';
import classNames from 'classnames';

const Section = ({
    children,
    modifier = '',
    isScrollable = false,
    noMarginBottom = false,
    isMainSection = false,
    whiteBackgroundMobile = false,
    halfHeight = false,
    overflowHidden = false,
    hidePrint = false,
    fullHeight = false,
    noPaddingTop = false,
}) => {
    const classes = classNames(
        s.Root,
        [s[`Root--${modifier}`]],
        { [s['Root--Scrollable']]: isScrollable },
        { [s['Root--NoMarginBottom']]: noMarginBottom },
        { [s['Root--MainSection']]: isMainSection },
        { [s['Root--HalfHeight']]: halfHeight },
        { [s['Root--WhiteBackgroundMobile']]: whiteBackgroundMobile },
        { [s['Root--OverflowHidden']]: overflowHidden },
        { [s['Root--HidePrint']]: hidePrint },
        { [s['Root--FullHeight']]: fullHeight },
        { [s['Root--NoPaddingTop']]: noPaddingTop }
    );

    return (
        <section className={classes}>
            <div className={s.Container}>
                {children && (
                    <div className={s.Content}>
                        {children}
                        {isMainSection && isScrollable && (
                            <div className={s.MarginBottom}></div>
                        )}
                    </div>
                )}
            </div>
        </section>
    );
};

Section.propTypes = {
    children: PropTypes.node,
    modifier: PropTypes.string,
    isScrollable: PropTypes.bool,
    noPaddingTop: PropTypes.bool,
};

export default Section;
